import { render, staticRenderFns } from "./AddInvoiceModal.vue?vue&type=template&id=22fe0a35&"
import script from "./AddInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./AddInvoiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports